import _ from 'lodash';
import React from 'react';

import styles from './RadioGroup.scss';

export default class RadioGroup extends React.Component {
  constructor() {
    super();

    this.name = _.uniqueId('radio-group-');
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(element) {
    const newValue = element.target.value;
    if (newValue !== this.props.value) {
      this.props.onChange(newValue);
    }
  }

  render() {
    const {options, value} = this.props;

    return (
      <div className={styles.group}>
        {
          options.map(option => {
            return (
              <label key={option.value}>
                <input
                  type='radio'
                  name={this.name}
                  value={option.value}
                  checked={option.value === value}
                  onChange={this.handleChange}
                />
                {option.name}
              </label>
            );
          })
        }
      </div>
    );
  }
}

RadioGroup.propTypes = {
  options: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func.isRequired,
  value: React.PropTypes.string,
};

RadioGroup.defaultProps = {value: ''};



// WEBPACK FOOTER //
// ./src/components/input/components/RadioGroup.jsx